import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { catalogBibShape, bibShape, libraryShape } from '@bibliocommons/bc-prop-types';
import { selectExcerptsForCurrentBib } from 'app/selectors/bibs/EvaluationSelector';
import { selectCatalogBib } from 'app/selectors/catalogBibs/CatalogBibSelector';
import { selectBibEntities } from 'app/selectors/EntitiesSelector';
import { selectCurrentLibrary } from 'app/selectors/LibrarySelector';
import { BibExcerpt } from '.';

export class BibExcerptContainer extends React.PureComponent {
  render() {
    return <BibExcerpt {...this.props} />;
  }
}

BibExcerptContainer.propTypes = {
  excerpt: PropTypes.string,
  catalogBib: catalogBibShape.isRequired,
  bib: bibShape.isRequired,
  currentLibrary: libraryShape.isRequired
};

const mapStateToProps = state => {
  const catalogBib = selectCatalogBib(state);
  return {
    excerpt: selectExcerptsForCurrentBib(state),
    catalogBib,
    bib: selectBibEntities(state).get(catalogBib.get('metadataId')),
    currentLibrary: selectCurrentLibrary(state)
  };
};

export default connect(mapStateToProps)(BibExcerptContainer);
